import { Card } from "design-system/molecules/Card"
import { ChartConfig } from "design-system/molecules/Chart"
import { StackedActivityChart } from "design-system/organisms/insights/StackedActivityChart"
import { getBackofficeActivityOpacity } from "modules/backoffice/lib/getBackofficeActivityOpacity"
import { useTranslation } from "react-i18next"
import { GetBackofficeFlagsActivityResponseDataSchema, TimeFrame } from "schema"
import { z } from "zod"

type ActivityData = z.infer<typeof GetBackofficeFlagsActivityResponseDataSchema>

type Props = {
  data: ActivityData | undefined
  isPending: boolean
  timeFrame: TimeFrame
}

export function BackofficeFlagsActivity({ data, isPending, timeFrame }: Props) {
  const { t } = useTranslation()

  const chartConfig = {
    top1: { label: t("backoffice.flags.activity.friction"), color: "var(--neutral)" },
    top2: { label: t("backoffice.flags.activity.issue"), color: "var(--testing-2)" },
  } satisfies ChartConfig

  return (
    <Card className="p-4">
      <StackedActivityChart
        data={data?.dailyCount.map((day) => ({
          ...day,
          opacity: getBackofficeActivityOpacity(day.date, timeFrame),
        }))}
        isPending={isPending}
        chartConfig={chartConfig}
        hideZeroTooltipEntries
        chartClassName="h-[140px]"
        noDataT={{
          title: t("backoffice.flags.activity.noData.title"),
          description: t("backoffice.flags.activity.noData.description"),
        }}
      />
    </Card>
  )
}
